module.exports = __webpack_public_path__ + "images/b180af8729c5cdef198f988ec5b59eec.jpg";